---
title: Automix效果评估系统
date: 2025-11-18
author: carrus2049
tags: [评估, 系统设计, 方法论]
excerpt: 本文介绍了Automix效果评估系统的设计哲学、数据选择方法、评估维度和流程。
---

## 背景与设计哲学

至251118，Spotify、Apple Music、酷狗音乐、QQ音乐四个平台都已实装Automix功能。
各平台功能的策略和效果均有可见的差异。为了更好量化Automix效果以作为优化功能体验的依据，兹构建Automix效果评估系统。

系统的构建遵循如下原则：

- 采样多个数据来源，各平台来源的内容需占比大致相同。
- 评估维度需涵盖Automix效果的各个方面，包括技术指标、主观听感、过渡质量、自动化与可复现性。
- 流程标准化，确保评估结果的客观性和可重复性。
- 评估结果需可视化、可追溯。

## 数据集选择与构建

### 歌单分类
- 
| 歌单名称                       | 来源平台 | 流派     | 歌曲数 | link_sp | link_am | link_kg | link_qq |
|------------------------------|---------|---------|-------|-------------|----------------|-------------|------------|
| Electro Chill 2024            | sp     | 电子     | 40    | [点此](https://open.spotify.com/playlist/xxxx) | [点此](https://music.apple.com/playlist/yyyy) | [点此](https://www.kugou.com/playlist/zzzz) | [点此](https://y.qq.com/n/playlist/aaaa) |
| 华语流行热歌精选                 | kg     | 流行     | 50    | [点此](https://open.spotify.com/playlist/bbbb) | [点此](https://music.apple.com/playlist/cccc) | [点此](https://www.kugou.com/playlist/123456) | [点此](https://y.qq.com/n/playlist/3333) |
| Indie Sunday                  | am     | 独立     | 30    | [点此](https://open.spotify.com/playlist/dddd) | [点此](https://music.apple.com/playlist/8888) | [点此](https://www.kugou.com/playlist/eeee) | [点此](https://y.qq.com/n/playlist/ssss) |
| QQ动感舞曲                     | qq      | 舞曲     | 45    | [点此](https://open.spotify.com/playlist/ffff) | [点此](https://music.apple.com/playlist/gggg) | [点此](https://www.kugou.com/playlist/hhhh) | [点此](https://y.qq.com/n/playlist/987654) |
| 浩室节奏 Groove House          | am      | House   | 25    | [点此](https://open.spotify.com/playlist/iiii) | [点此](https://music.apple.com/playlist/jjjj) | [点此](https://www.kugou.com/playlist/kkkk) | [点此](https://y.qq.com/n/playlist/llll) |
| 新世代嘻哈精选                  | sp      | 嘻哈     | 35    | [点此](https://open.spotify.com/playlist/mmmm) | [点此](https://music.apple.com/playlist/nnnn) | [点此](https://www.kugou.com/playlist/oooo) | [点此](https://y.qq.com/n/playlist/pppp) |

** 录屏测试会搞乱我的sp个性化推荐，先不评sp
## 评估维度
### 前提
- 熟悉程度，艺术家x歌曲

### Transition
- Overall Smoothness 1-5
- Transition Cue Point 1-5
- Lead Vocal Overlay 1-5

### Additional info
- Beat not aligned

## 评估流程
- 各平台评测歌单开启功能录屏。
- 根据音视频检测分割录屏段落，按照过渡片段展示
- 
## 结果展示与分析

## 后续优化方向
